var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#E4F5FF",
    stroke: "#2177FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04142 10.8065V9.19111C8.04142 8.07592 8.95551 7.17187 10.0831 7.17188C11.2107 7.17187 12.1248 8.07592 12.1248 9.19111L12.1248 11.4123C12.1248 11.9699 11.6677 12.4219 11.1039 12.4219C10.5401 12.4219 10.0831 11.9699 10.0831 11.4123L10.0831 9.19111",
    stroke: "#2177FE",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2915 7.17188H13.4506C15.353 7.17188 16.3042 7.17188 16.9647 7.63728C17.154 7.77062 17.322 7.92876 17.4637 8.10689C17.9582 8.7286 17.9582 9.62383 17.9582 11.4143V12.8991C17.9582 14.6277 17.9582 15.4919 17.6846 16.1822C17.2449 17.2919 16.3148 18.1672 15.1358 18.5811C14.4024 18.8385 13.4841 18.8385 11.6476 18.8385C10.5981 18.8385 10.0734 18.8385 9.65429 18.6914C8.98055 18.4549 8.44911 17.9547 8.19782 17.3206C8.0415 16.9262 8.0415 16.4323 8.0415 15.4446V13.0052",
    stroke: "#2177FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9581 13.0078C17.9581 14.0817 17.0875 14.9523 16.0136 14.9523C15.6253 14.9523 15.1674 14.8842 14.7898 14.9854C14.4543 15.0753 14.1922 15.3373 14.1023 15.6729C14.0011 16.0505 14.0692 16.5083 14.0692 16.8967C14.0692 17.9706 13.1986 18.8411 12.1248 18.8411",
    stroke: "#2177FE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.5db921f74280d65900273f82591fa418.svg";
export { ForwardRef as ReactComponent };